import { GeneralAARUISingleEntryConfig } from "../Components/ui/react/core-general-aar-ui";
import { PageType } from "../../misc/tools";
export interface GameDataConfig {
    isVisibleFocusEnabled: boolean;
    isAudioEnabled: boolean;
    fontSizeMultiplier: FontSizeMultiplier;
    isClosedCaptionEnabled: boolean;
    isMotionEnabled: boolean;
    isAnimationsEnabled: boolean;
    lastVisitedScenarioIndx: number;
    scenarios: SingleScenarioConfig[];
}
export interface SingleScenarioConfig {
    scenarioWindow: PageType;
    isLocked: boolean;
    isCompleted: boolean;
    gaugeValue: number;
    gaugeMax: number;
    score: number;
    maxScore: number;
    area: number;
    MaxQuestions: number;
    aarEntries: GeneralAARUISingleEntryConfig[]
}

export enum FontSizeMultiplier {
    small = 0.5,
    med = 1,
    big = 1.5
}